module.exports = __webpack_public_path__ + "img/default-bundle-cover.bff24b78.png";